<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(prenotazione.id != null ? 'Prenotazione #' + prenotazione.id + ' - Evento #' + prenotazione.id_scheda:'Nuova prenotazione' + ' - Evento #' + prenotazione.id_scheda)">

                    <b-container fluid class="mx-auto text-left" v-if="(showdettaglio1 || prenotazione.id == null) && showdettaglio2 && showdettaglio3">
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datainizioev">Data inizio evento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="datamin" id="datainizioev" type="date" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datafineev">Data fine evento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="datamax" id="datafineev" type="date" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datainizio">Data inizio prenotazione:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="prenotazione.datainizio" id="datainizio" type="date"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datafine">Data fine prenotazione:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="prenotazione.datafine" id="datafine" type="date"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="prenotazione.tipoevento == 'G'">
                                    <b-col sm="3"><label for="orainizioev">Ora inizio evento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="oramin" id="orainizioev" type="time" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="prenotazione.tipoevento == 'G'">
                                    <b-col sm="3"><label for="orafineev">Ora fine evento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="oramax" id="orafineev" type="time" disabled></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="prenotazione.tipoevento == 'G'">
                                    <b-col sm="3"><label for="orainizio">Ora inizio prenotazione:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="prenotazione.orainizio" id="orainizio" type="time"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="prenotazione.tipoevento == 'G'">
                                    <b-col sm="3"><label for="orafine">Ora fine prenotazione:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="prenotazione.orafine" id="orafine" type="time"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="note">Note:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea id="note" v-model="prenotazione.note" :rows="3"></b-form-textarea>
                                    </b-col>
                                </b-row>

                                <b-row v-show="getShowImportiPagamento()" class="my-1">
                                    <b-col sm="3"><label for="importoacconto">Importo acconto:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group prepend="€">
                                            <b-form-input v-model="prenotazione.importoacconto" id="importoacconto" type="number"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row v-show="getShowImportiPagamento()" class="my-1">
                                    <b-col sm="3"><label for="importosaldo">Importo saldo:</label></b-col>
                                    <b-col sm="9">                                        
                                        <b-input-group prepend="€">
                                            <b-form-input v-model="prenotazione.importosaldo" id="importosaldo" type="number"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row v-show="getShowImportiPagamento()" class="my-1">
                                    <b-col sm="3"><label for="importoscontoacconto">Importo sconto acconto:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group prepend="€">
                                            <b-form-input v-model="prenotazione.importoscontoacconto" id="importoscontoacconto" type="number"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row v-show="getShowImportiPagamento()" class="my-1">
                                    <b-col sm="3"><label for="importoscontosaldo">Importo sconto saldo:</label></b-col>
                                    <b-col sm="9">                                        
                                        <b-input-group prepend="€">
                                            <b-form-input v-model="prenotazione.importoscontosaldo" id="importoscontosaldo" type="number"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row v-show="(getShowImportiPagamento() || prenotazione.totalepagato > 0) && prenotazione.totacconto != ''" class="my-1">
                                    <b-col sm="3"><label for="totacconto">Acconto riscosso/totale:</label></b-col>
                                    <b-col sm="9">                                        
                                        <b-input-group prepend="€">
                                            <b-form-input disabled :style="getImportoStyle(prenotazione.totacconto)" v-model="prenotazione.totacconto" id="totacconto" type="text"></b-form-input>
                                        </b-input-group>                                     
                                    </b-col>
                                </b-row>

                                <b-row v-show="(getShowImportiPagamento() || prenotazione.totalepagato > 0) && prenotazione.totsaldo != ''" class="my-1">
                                    <b-col sm="3"><label for="importosaldo">Saldo riscosso/totale:</label></b-col>
                                    <b-col sm="9">                                    
                                        <b-input-group prepend="€">
                                            <b-form-input disabled :style="getImportoStyle(prenotazione.totsaldo)" v-model="prenotazione.totsaldo" id="totsaldo" type="text"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flagsta">Stato:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="prenotazione.flagsta" :options="options_stati" id="flagsta">
                                            
                                        </b-form-select>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="socio">Socio:</label></b-col>
                                    <b-col sm="9">
                                        
                                        <b-input-group>
                                            <b-form-input v-model="socioVis" id="socio" type="text" disabled></b-form-input>
                                            <b-input-group-append>
                                                <!-- <b-btn v-show="socioVis !== ''" variant="secondary" @click="delSocio()">Elimina</b-btn> -->
                                                <b-btn v-show="prenotazione.id == null || prenotazione.id_socio == null" variant="primary" @click="selSocio()">Seleziona</b-btn>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-if="prenotazione.id != null">
                                    <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="prenotazione.datains" id="datains" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>                                
                                <b-row class="my-1" v-if="prenotazione.id != null">
                                    <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="prenotazione.uteins" id="uteins" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-3" v-show="parametri.flgpagamenti == 'S' && prenotazione.id != null && prenotazione.id_socio != null">
                                    <b-col sm="9" offset-sm="3">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="pagamenti()">
                                            Pagamenti
                                        </b-button>
                                    </b-col>                                    
                                </b-row>
                                <b-row class="my-3">
                                    <b-col sm="6" offset-sm="3">
                                        <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                            <div v-if="prenotazione.id != null">
                                                Salva
                                            </div>
                                            <div v-else>
                                                Inserisci
                                            </div>
                                        </b-button>
                                    </b-col>
                                </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>

                </b-card>
            </b-col>
        </b-row>
    </b-container>

    <!-- Modal Component -->
    <b-modal size="lg" v-model="sociModal.show" title="Seleziona il socio">
        <!-- <p class="my-2">Seleziona il socio</p> -->

        <div class="text-left">
            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="sociModal.filter" placeholder="Cerca..." />
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive small id="main-table" striped hover show-empty :items="sociModal.items" :fields="sociModal.fields" :current-page="sociModal.currentPage" :per-page="sociModal.perPage" :filter="sociModal.filter" :sort-by.sync="sociModal.sortBy" :sort-desc.sync="sociModal.sortDesc"
                @filtered="onFiltered">
                <template slot="id" scope="row">{{row.value}}</template>
                <template slot="cognome" scope="row">{{row.value}}</template>
                <template slot="nome" scope="row">{{row.value}}</template>
                <!-- <template slot="matricola" scope="row">{{row.value}}</template> -->
                <template slot="email" scope="row">{{row.value}}</template>
                <template slot="seleziona" scope="row">
                <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-btn size="sm" variant="danger" @click.stop="seleziona(row.item,row.index,$event.target)">Seleziona</b-btn>
            </template>
            </b-table>


            <div class="row my-1">
                <div class="col-md-7 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="sociModal.perPage" v-model="sociModal.currentPage" />
                </div>
                <div class="col-md-5 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="sociModal.pageOptions" v-model="sociModal.perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>


        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="secondary" @click="sociModal.show=false" style="margin: 2px;">
                Chiudi
            </b-btn>
        </div>
    </b-modal>           

</div>
</template>

<script>
import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'

import {
    Prenotazione,
    Categoria,
    Socio,
    Visibilità
} from '../classes.js'

import {
    ctrlVismenu
} from '../util.js'



export default {
    name: 'appdettaglio',
    data: function () {
        return {                        
            namespace: NAMESPACE,
            prenotazione: {
                id: this.$route.params.id,
                id_scheda: this.$route.params.id_scheda,
                datainizio: '',
                datafine: '',
                note: '',
                datains: null,
                uteins: '',
                id_socio: null,
                nomesocio: '',
                cognomesocio: '',
                accountsocio: '',
                importoacconto: 0,
                importosaldo: 0,
                importoscontoacconto: 0,
                importoscontosaldo: 0,
                totalesaldo: 0,
                totaleacconto: 0,
                totalepagato: 0,
                totsaldo: '',
                totacconto: '',
                orainizio: '',
                orafine: '',
                flagsta: 'I',
                tipoevento: '',
                tipo: 'E',
                tipopagamentoevento: '',
            },
            parametri: null,
            options: [],
            options_stati: [],
            error: '',
            showerror: false,
            showdettaglio1: false,
            showdettaglio2: false,
            showdettaglio3: false,
            datamin: null,
            datamax: null,
            oramin: null,
            oramax: null,
            dismissSecs: 2,
            dismissCountDown: 0,
            sociModal: {
                show: false,
                items: [],
                fields: {
                    id: {
                        label: '#',
                        sortable: true
                    },
                    cognome: {
                        label: 'Cognome',
                        sortable: true
                    },
                    nome: {
                        label: 'Nome',
                        sortable: true
                    },
                    email: {
                        label: 'Email',
                        sortable: true
                    },
                    seleziona: {
                        label: ' ',
                        'class': 'text-right'
                    }
                },
                currentPage: 1,
                perPage: 5,
                pageOptions: [{
                    text: 5,
                    value: 5
                }, {
                    text: 10,
                    value: 10
                }, {
                    text: 15,
                    value: 15
                }],
                sortBy: null,
                sortDesc: false,
                filter: null,                
                totalRowsFilter: null,
            },     
        };
    },
    watch: {
        'prenotazione.datainizio': function(val, oldVal) {
            //stare attenti scatta anche al caricamento pagina
            //in questo caso non da noia perchè il campo datafine è popolato
            if (val != '' && this.prenotazione.datafine == '' && this.prenotazione.tipoevento == 'S') {
                var new_date = moment(val, "YYYY-MM-DD").add(6, 'days').format("YYYY-MM-DD");
                this.prenotazione.datafine = new_date;
            }
            else if (val != '' && this.prenotazione.datafine == '' && this.prenotazione.tipoevento == 'G') {
                //var new_date = moment(val, "YYYY-MM-DD").add(6, 'days').format("YYYY-MM-DD");
                //this.prenotazione.datafine = new_date;              
                this.prenotazione.datafine = val;
            }
            
        }
    },
    computed:{
        socioVis: {
            // getter
            get: function () {
                if(this.prenotazione.id_socio == null || this.prenotazione.id_socio == 'null' || parseInt(this.prenotazione.id_socio) <= 0){
                    return '';
                }
                else{
                    return this.prenotazione.cognomesocio + " " + this.prenotazione.nomesocio + " - " + this.prenotazione.accountsocio;
                }
                
            },
            // setter
            set: function (newValue) {

            }
        },
        totalRows: {
            // getter
            get: function () {
                return this.sociModal.totalRowsFilter || this.sociModal.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.sociModal.totalRowsFilter = newValue;
            }
        }
    },
    methods: {   
        // delSocio(){

        //     this.prenotazione.id_socio = null;
        //     this.prenotazione.nomesocio = '';
        //     this.prenotazione.cognomesocio = '';
        //     this.prenotazione.accountsocio = '';

        // },   
        seleziona(item, index, button) {    
            
            this.prenotazione.id_socio = item.id;
            this.prenotazione.nomesocio = item.nome;
            this.prenotazione.cognomesocio = item.cognome;
            this.prenotazione.accountsocio = item.email;

            this.getScontoEventoSocio();
            
            //this.sociModal.show = false;

        },   
        pagamenti() {

            this.$router.push({
                path: `/app/pagamenti/id_evento/${this.prenotazione.id_scheda}/id_socio/${this.prenotazione.id_socio}/id_prenotazione/${this.prenotazione.id}`
            });
            
        },         
        getShowImportiPagamento() {

            //console.logconsole.log("Tipo pag evento: " + this.prenotazione.tipopagamentoevento);

            return (this.parametri.flgpagamenti == 'S' && this.prenotazione.tipopagamentoevento != 'N' /*this.prenotazione.tipopagamentoevento == 'M'*/);
        },          
        getImportoStyle(importo){
            
            if(typeof importo != 'undefined' && importo.indexOf("/") >= 0){
                var parz = Number.parseFloat(importo.split('/')[0]);
                var tot = Number.parseFloat(importo.split('/')[1]);
                if(parz == tot){
                    return "font-weight:bold;color:green;";
                }
                if(parz < tot){
                    return "font-weight:bold;color:red;";
                }
                else{
                    return "font-weight:bold;color:blue;";
                }
            }
            return "";
        },
        getScontoEventoSocio(){

            var token = localStorage.getItem('token');
            //this.axios.get(NAMESPACE + 'rest/soci', {
                this.axios.get(NAMESPACE + 'rest/sconti/id_scheda/' + this.prenotazione.id_scheda + '/tipo/' + 'E' + '/id_socio/' + this.prenotazione.id_socio, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);
                            var res = response.data.message;
                            var importoscontoaccontoAux = 0;
                            var importoscontosaldoAux = 0;
                            if (res.length > 0) {                                

                                //forse può essere fatta diversamente e meglio
                                for (var i = 0; i < res.length; i++) {
                                    if(importoscontoaccontoAux + importoscontosaldoAux < Math.max(res[i].importoacconto,0) + Math.max(res[i].importosaldo,0)){
                                        importoscontoaccontoAux = Math.max(res[i].importoacconto,0);
                                        importoscontosaldoAux = Math.max(res[i].importosaldo,0);
                                    }
                                }

                            } 

                            this.prenotazione.importoscontoacconto = importoscontoaccontoAux;
                            this.prenotazione.importoscontosaldo = importoscontosaldoAux;                            

                            this.sociModal.show = false;

                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        this.sociModal.showerror = true;
                        this.sociModal.error = "Errore: " + e.message;
                        alert("Errore caricamento sconti: " + e.message); //si visualizza anche con alert per dargli più rilevanza
                    }

                })
                .catch(e => {
                    this.sociModal.showerror = true;
                    this.sociModal.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    alert("Errore caricamento sconti: " + e.message); //si visualizza anche con alert per dargli più rilevanza
                });



        }, 
        selSocio() {

                var token = localStorage.getItem('token');
                //this.axios.get(NAMESPACE + 'rest/soci', {
                    this.axios.get(NAMESPACE + 'rest/soci/id_scheda/' + this.prenotazione.id_scheda + '/tipo/E', {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                this.sociModal.items = response.data.message;
                                this.sociModal.items.forEach(function(element, index) {
                                    delete element.uteins; //per motivi di ricerca
                                });
                                this.sociModal.show = true;

                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            this.sociModal.showerror = true;
                            this.sociModal.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.sociModal.showerror = true;
                        this.sociModal.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });



        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },        
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.sociModal.currentPage = 1;
        },
        insert() {

                var appdettaglio = this;

                var regexOra = new RegExp("^$|^(([01][0-9])|(2[0-3])):[0-5][0-9]$");

                if (this.prenotazione.datainizio == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo data inizio prenotazione vuoto!";

                } else if (this.prenotazione.datafine == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo data fine prenotazione vuoto!";

                } else if (this.prenotazione.tipoevento == 'G' && this.prenotazione.orainizio == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo ora inizio prenotazione vuoto!";

                } else if (this.prenotazione.tipoevento == 'G' && this.prenotazione.orafine == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo ora fine prenotazione vuoto!";

                } else if (this.prenotazione.note == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo note vuoto!";

                } else if (this.prenotazione.tipoevento == 'G' && this.prenotazione.datainizio != this.prenotazione.datafine) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo data inizio prenotazione deve essere uguale al campo data fine prenotazione per evento di tipo giornaliero!";

                } else if (this.prenotazione.tipoevento == 'G' && !regexOra.test(this.prenotazione.orainizio)) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo ora inizio prenotazione con formato diverso da HH:mm!";

                } else if (this.prenotazione.tipoevento == 'G' && !regexOra.test(this.prenotazione.orafine)) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo ora fine prenotazione con formato diverso da HH:mm!";

                } else if (this.prenotazione.datainizio < this.datamin) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Data inizio prenotazione minore della data inizio evento!";

                } else if (this.prenotazione.datafine > this.datamax) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Data fine prenotazione maggiore della data fine evento!";

                } else if (this.prenotazione.tipoevento == 'G' &&  this.prenotazione.orainizio < this.oramin) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Ora inizio prenotazione minore dell'ora inizio evento giornaliero!";

                } else if (this.prenotazione.tipoevento == 'G' &&  this.prenotazione.orafine > this.oramax) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Ora fine prenotazione maggiore dell'ora fine evento giornaliero!";

                }else if (this.prenotazione.datafine < this.prenotazione.datainizio) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Data inizio prenotazione maggiore della data fine prenotazione!";

                } else if (this.prenotazione.tipoevento == 'G' && this.prenotazione.orafine <= this.prenotazione.orainizio) {         
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Ora inizio prenotazione maggiore o uguale all'ora fine prenotazione!";

                } else if (this.prenotazione.importoacconto < 0 && this.getShowImportiPagamento()) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Importo acconto < 0!";

                } else if (this.prenotazione.importosaldo < 0 && this.getShowImportiPagamento()) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Importo saldo < 0!";

                } else if (this.prenotazione.id_socio == null && this.getShowImportiPagamento()) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Nessun socio selezionato, obbligatori se pagamenti gestiti!";

                } else {

                    var json = JSON.stringify(this.prenotazione);

                    //console.log("Save: " + JSON.stringify(json));

                    var token = localStorage.getItem('token');
                    this.axios.post(NAMESPACE + 'rest/prenotazione', json, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;
                                    if (res.length > 0) {
                                        this.showpassword = false;
                                        this.prenotazione = res[0];

                                        this.prenotazione.totacconto = Number.parseFloat((this.prenotazione.totalesaldo == 0 ? this.prenotazione.totalepagato : Math.min(this.prenotazione.totaleacconto, this.prenotazione.totalepagato))).toFixed(2) + "/" + Number.parseFloat(this.prenotazione.totaleacconto).toFixed(2);
                                        this.prenotazione.totacconto = (this.prenotazione.totacconto == '0.00/0.00' ? '' : this.prenotazione.totacconto);

                                        var auxdiff = this.prenotazione.totalepagato - (this.prenotazione.totalesaldo == 0 ? this.prenotazione.totalepagato : Math.min(this.prenotazione.totaleacconto, this.prenotazione.totalepagato));
                                        auxdiff = (auxdiff < 0 ? 0 : auxdiff);
                                        this.prenotazione.totsaldo = Number.parseFloat(auxdiff).toFixed(2) + "/" + Number.parseFloat(this.prenotazione.totalesaldo).toFixed(2); 
                                        this.prenotazione.totsaldo = (this.prenotazione.totsaldo == '0.00/0.00' ? '' : this.prenotazione.totsaldo);

                                        this.showerror = false;
                                        this.showdettaglio1 = true; //anche se non dovrebbe servire                                 
                                        this.dismissCountDown = this.dismissSecs;

                                        setTimeout(function() {
                                            //window.history.back();
                                            appdettaglio.$router.go(-1);
                                        }, 2500);

                                    } else {
                                        throw new Error("Errore dati non trovati!");
                                    }


                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                appdettaglio.showerror = true;
                                appdettaglio.error = "Errore: " + e.message;
                            }

                        })
                        .catch(e => {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        });
                }

            }

    },
    created: function () {  

           
        
            if(!ctrlVismenu("R")){
                this.$router.replace('/accessdenied');
                return;
            } 
            
            var prenotazione1 = new Prenotazione();
            var options = [];
            var listaStati = Object.keys(prenotazione1.getListaStati("E"));
            for (var i = 0; i < listaStati.length; i++) {
                options.push({
                    value: listaStati[i],
                    text: prenotazione1.getStatoByFlag(listaStati[i])
                });
            }
            this.options_stati = options;

            var id = this.prenotazione.id; //se è la prima volta si prova a prendere da getid 

            var appdettaglio = this;
            var token = localStorage.getItem('token');
            if (id != null) {          
                //id_scheda/{id_scheda}/tipo/{tipo}
                this.axios.get(NAMESPACE + 'rest/prenotazioni/tipo/E/'+ id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.prenotazione = res[0];

                                    //alert("Res: " + JSON.stringify(this.prenotazione));

                                    this.prenotazione.totacconto = Number.parseFloat((this.prenotazione.totalesaldo == 0 ? this.prenotazione.totalepagato : Math.min(this.prenotazione.totaleacconto, this.prenotazione.totalepagato))).toFixed(2) + "/" + Number.parseFloat(this.prenotazione.totaleacconto).toFixed(2);
                                    this.prenotazione.totacconto = (this.prenotazione.totacconto == '0.00/0.00' ? '' : this.prenotazione.totacconto);

                                    var auxdiff = this.prenotazione.totalepagato - (this.prenotazione.totalesaldo == 0 ? this.prenotazione.totalepagato : Math.min(this.prenotazione.totaleacconto, this.prenotazione.totalepagato));
                                    auxdiff = (auxdiff < 0 ? 0 : auxdiff);
                                    this.prenotazione.totsaldo = Number.parseFloat(auxdiff).toFixed(2) + "/" + Number.parseFloat(this.prenotazione.totalesaldo).toFixed(2); 
                                    this.prenotazione.totsaldo = (this.prenotazione.totsaldo == '0.00/0.00' ? '' : this.prenotazione.totsaldo);

                                    this.showdettaglio1 = true;
                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

            //chiamo il servizio che mi restituisce le date dell'evento
            this.axios.get(NAMESPACE + 'rest/eventi/' + this.prenotazione.id_scheda, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {

                                this.datamin = res[0].datainizio;
                                this.datamax = res[0].datafine;
                                this.oramin = res[0].orainizio;
                                this.oramax = res[0].orafine;
                                this.prenotazione.tipoevento = res[0].tipo;
                                if(this.prenotazione.id == null && res[0].tipopagamento == 'A'){//se inserimento ricopio gli importo dall'evento alla prenotazione
                                    this.prenotazione.importoacconto = res[0].importoacconto;
                                    this.prenotazione.importosaldo = res[0].importosaldo; 
                                }                                   
                                this.prenotazione.tipopagamentoevento = res[0].tipopagamento;
                                //alert("Tipo evento " + this.tipoevento)

                                //console.log("Res: " + JSON.stringify(this.prenotazione));

                                this.showdettaglio2 = true;

                            } else {
                                throw new Error("Errore evento non trovato!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });


            //PAREMETRI
            this.axios.get(NAMESPACE + 'rest/cral', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            //alert("Ret: " + JSON.stringify(res))
                            if (typeof res == "object") {

                                this.parametri = res;
                                this.showdettaglio3 = true;

                            } else {
                                throw new Error("Errore parametri non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

    },
        mounted: function() {
            
          
            
        }

}
</script>
